import {connect} from 'react-redux';

import {AppPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {makeMapDispatchToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {MessageUndoBannerState} from '../../../../store/panels/app/banners/bannersState';
import {undoMessageBannerAsyncAction} from '../../../../store/panels/app/banners/undoBannersActions';
import {MessageUndoBanner} from './messageUndoBanner';

/*
 * Props.
 */

interface MessageUndoBannerContainerProps {
  panelId: AppPanelId;
  state: MessageUndoBannerState;
}

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps<MessageUndoBannerContainerProps>()((props) => ({
  onUndoClick: () => undoMessageBannerAsyncAction(props.panelId, props.state),
}));

export const MessageUndoBannerContainer = connect(null, mapDispatchToProps)(MessageUndoBanner);
